const glossaryWord = "_rsg1qxbnic";

export { glossaryWord };
import "./atom.glossary-definition.style.linaria.module.css";
//# sourceMappingURL=atom.glossary-definition.style.js.map
